import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";
import { setmonthEdit } from "../../../Redux/Reducers/BudgetInformation/AdministrativeCosts";

const MonthsImplementationDirectBudgetCosts = (props) => {
  // let dataEditMonth=[]
  const [data, setData] = useState(props.data.map((item) => ({ ...item })));
  const TimelineInformationChange = useSelector(
    (state) => state.BI_TimelineInformation.EditBI_TimelineInformation
  );

  useEffect(() => {
    setData(props.data.map((item) => ({ ...item })));
    props.setDataEditMonth(props.data.map((item) => ({ ...item })));
    props.setarrayOfMonthsFilterAdd(props.data.map((item) => ({ ...item })));
  }, [TimelineInformationChange]);


  console.log(data,"sssssssssssssssdwdwdw");
  
  

  return (
    <>
      {props.action == "add" ? (
        <>
          <div className="containerMonthName">
            {props.data.map((ele, ind) => {
              //console.log(ele, "sssssssssssssssssssssssssss");

              return (
                <div className="containerOneBlock">
                  <div className="oneBlock">{ele.nameMonth}</div>
                  <div className="containerInput">
                    <input
                      className="numberInput"
                      placeholder="0"
                      id={`uniqueID${ind}`}
                      type="number"
                      onChange={(e) => {
                        ele.totalValue = parseFloat(e.target.value);
                      }}
                      // defaultValue={ele.totalValue}
                      disabled={!ele.isChecked}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                    />
                  </div>
                  <div className="containercheckbox">
                    <input
                      type="checkbox"
                      // checked={ele.isChecked}
                      defaultChecked={ele.isChecked}
                      onChange={(e) => {
                        ele.isChecked = e.target.checked;
                        document.getElementById(`uniqueID${ind}`).disabled =
                          !e.target.checked;

                        if (ele.isChecked == false) {
                          document.getElementById(`uniqueID${ind}`).value = 0;
                          ele.totalValue = 0;
                        }
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          {props.data ? (
            <>
              <div className="containerMonthName">
                {data.map((ele, ind) => {
                  return (
                    <div className="containerOneBlock">
                      <div className="oneBlock">{ele.nameMonth}</div>
                      <div className="containerInput">
                        <input
                          className="numberInput"
                          id={`uniqueID${ind}`}
                          type="number"
                          onChange={(e) => {
                            ele.totalValue = parseFloat(e.target.value);
                            props.setDataEditMonth(data);
                            props.setarrayOfMonthsFilterAdd(data);

                            // //console.log(dataEditMonth,"sdsdsdsd");
                          }}
                          defaultValue={ele.totalValue}
                          disabled={props.action === "view" || !ele.isChecked}
                          onFocus={(e) =>
                            e.target.addEventListener(
                              "wheel",
                              function (e) {
                                e.preventDefault();
                              },
                              { passive: false }
                            )
                          }
                        />
                      </div>
                      <div className="containercheckbox">
                        <input
                          type="checkbox"
                          // checked={ele.isChecked}
                          disabled={props.action == "view"}
                          defaultChecked={ele.isChecked}
                          onChange={(e) => {
                            //console.log(ele.isChecked, "sdsdsdwwwwww");
                            // //console.log(e.target.checked,"sdsdsdwwwwww");

                            ele.isChecked = e.target.checked;
                            document.getElementById(`uniqueID${ind}`).disabled =
                              !e.target.checked;

                            if (ele.isChecked == false) {
                              document.getElementById(
                                `uniqueID${ind}`
                              ).value = 0;
                              ele.totalValue = 0;
                            }

                            props.setDataEditMonth(data);
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default MonthsImplementationDirectBudgetCosts;
